export default __webpack_public_path__ + "static/media/a19.577b5af9.webp";